<div
    fxFlex="grow"
    class="item-title-wrapper"
    [ngClass]="{ 'title-collapsed': !expanded, 'edit-mode-wrapper': editMode.value }"
>
    <span
        fxLayoutGap="3px"
        fxLayout="row"
        fxLayoutAlign="start center"
        *ngIf="!editMode.value"
        (click)="onClearEditMode.emit(true)"
        class="title-item {{ disabled }}"
    >
        <mat-icon>title</mat-icon>
        <span>{{ item.value.title }}</span></span
    >
    <mat-form-field *ngIf="editMode.value" fxFlex="0 1 100%">
        <textarea
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="15"
            #input
            matInput
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            type="text"
            [formControl]="item.get('title') | cast"
        >
        </textarea>
    </mat-form-field>
</div>
<ng-container *ngIf="isMobile$ | async">
    <mat-icon *ngIf="disabled" class="add-ai-btn mobile-ai on-loading">smart_toy</mat-icon>
    <button
        [ngClass]="{ 'circle-indicator-expanded': expanded }"
        class="circle-trigger"
        (click)="$event.stopPropagation()"
        mat-button
        [matTooltip]="getToolTipValue(item.value.text_validation)"
        [matMenuTriggerFor]="menu"
    >
        <div class="circle-item {{ item.value.text_validation }}"></div>
    </button>
</ng-container>
<div
    [ngClass]="{ 'hide-bts': !expanded }"
    fxLayout="row"
    class="m-w-100 gap-small"
    fxLayoutAlign="start center"
    fxLayoutAlign.lt-md="end center"
    *ngIf="!loadingTitle.value"
>
    <ng-container *ngIf="!editMode.value">
        <button
            [disabled]="disabled"
            (click)="$event.stopPropagation(); editMode.next(true)"
            class="tools-btn"
            mat-icon-button
            matTooltip="Edit title"
            i18n-matTooltip="@@editTitle"
        >
            <mat-icon>edit</mat-icon>
        </button>
        <button
            [disabled]="!item?.value?.id"
            *ngIf="!loadingMaterialsCreation"
            class="tools-btn create-material"
            type="button"
            (click)="loadingMaterialsCreation = !loadingMaterialsCreation; $event.stopPropagation(); makeMaterial()"
            mat-icon-button
            matTooltip="Split into new material"
            i18n-matTooltip
        >
            <mat-icon>call_split</mat-icon>
        </button>
        <button
            *ngIf="!loadingMaterialsCreation"
            class="tools-btn create-material split-menu-btn"
            type="button"
            (click)="$event.stopPropagation(); splitMenuDisplayedOption = 'buttons'"
            #splitMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="splitMenu"
            mat-icon-button
            matTooltip="Split into many blocks"
            i18n-matTooltip
        >
            <mat-icon>content_cut</mat-icon>
        </button>
        <mat-menu
            #splitMenu="matMenu"
            class="split-menu-panel correct-alt-menu"
            [hasBackdrop]="true"
            [overlapTrigger]="false"
        >
            <div
                class="w-100 split-mi-wrapper"
                [ngClass]="{
                    'buttons-display': splitMenuDisplayedOption == 'buttons',
                    'Input-display': splitMenuDisplayedOption == 'blocksInput'
                }"
            >
                <div fxLayout="column" fxLayoutAlign="start start" class="split-buttons-wrapper">
                    <div
                        class="w-100"
                        mat-menu-item
                        (click)="splitMenuDisplayedOption = 'blocksInput'; $event.stopPropagation()"
                    >
                        <mat-icon>content_cut</mat-icon>
                        <span i18n> Split with AI </span>
                    </div>
                    <div
                        class="w-100 without"
                        mat-menu-item
                        (click)="
                            splitMenuDisplayedOption = 'buttons';
                            onSplitText.emit({ useAi: false });
                            onDisableSorting.emit(true)
                        "
                    >
                        <mat-icon>content_cut</mat-icon>
                        <span i18n> Split without AI </span>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" class="split-input-wrapper">
                    <span i18n>Set number of blocks</span>
                    <mat-form-field class="passing-data">
                        <mat-label i18n>Enter number</mat-label>
                        <input
                            matInput
                            type="number"
                            min="0"
                            [formControl]="splitText | cast"
                            (click)="$event.stopPropagation()"
                        />
                    </mat-form-field>
                    <button
                        color="primary"
                        mat-button
                        [disabled]="splitText.value == null || splitText.value == 0"
                        (click)="
                            onSplitText.emit({ useAi: true, blocksCount: splitText.value, index: index });
                            splitText.reset()
                        "
                        matMenuClose
                    >
                        <span i18n>Done</span>
                    </button>
                </div>
            </div>
        </mat-menu>
        <!-- <button
            [disabled]="true"
            class="tools-btn reasoning"
            type="button"
            (click)="$event.stopPropagation(); showReasoning()"
            mat-icon-button
            matTooltip="Show model reasoning"
            i18n-matTooltip
        >
            <mat-icon>psychology</mat-icon>
        </button> -->
        <app-kd-logo-loading *ngIf="loadingMaterialsCreation" size="small"></app-kd-logo-loading>

        <button
            [disabled]="!item.value.name"
            (click)="$event.stopPropagation(); tooltip.toggle()"
            (mouseenter)="tooltip.show()"
            class="tools-btn"
            #tooltip="matTooltip"
            mat-icon-button
            matTooltipClass="info-tooltip"
            [matTooltip]="tooltipInfo"
        >
            <mat-icon class="material-icons-outlined">info</mat-icon>
        </button>
        <!-- <button
            [disabled]="!item.value.name"
            (click)="$event.stopPropagation(); isVisible = !isVisible"
            class="tools-btn"
            #tooltip="matTooltip"
            mat-icon-button
            matTooltipClass="info-tooltip"
            [matTooltip]="isVisible ? 'Visible while playing' : 'Hidden while playing'"
        >
            <mat-icon>{{ isVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button> -->

        <button
            [disabled]="!item.value.name"
            (click)="$event.stopPropagation(); item.get('item_visibility').patchValue(!item.value.item_visibility)"
            class="tools-btn"
            mat-icon-button
            [matTooltip]="item.value.item_visibility ? 'Make it hidden while playing' : 'Make it visible while playing'"
            i18n-matTooltip
        >
            <mat-icon>{{ item.value.item_visibility ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <button
            [disabled]="!item.value.name"
            (click)="
                $event.stopPropagation(); item.get('headline_visibility').patchValue(!item.value.headline_visibility)
            "
            class="tools-btn"
            mat-icon-button
            [matTooltip]="
                item.value.headline_visibility ? 'Hide headline in playing mode' : 'Show headline in playing mode'
            "
            i18n-matTooltip
        >
            <mat-icon>{{ item.value.headline_visibility ? 'format_size' : 'format_clear' }}</mat-icon>
        </button>

        <button
            [disabled]="disabled"
            (click)="$event.stopPropagation(); onRegenerate.emit(index)"
            class="tools-btn-icon tools-btn regenerate"
            mat-icon-button
            matTooltip="Regenerate AI response"
            i18n-matTooltip="@@editTitle"
        >
            <mat-icon>autorenew</mat-icon>
        </button>

        <app-item-translator
            [ngClass]="item.value.language_id ? 'translator' : 'tools-btn'"
            class="translator"
            [disabled]="disabled || !item.value.name"
            [languageId]="item.value.language_id"
            (onTranslate)="onTranslate.emit($event)"
        ></app-item-translator>
        <!-- <ng-container *ngIf="item.value.title">
            <div *ngIf="item.value.updated_at != item.value.created_at" class="ai-wrapper">
                <mat-icon matTooltip="Edited by human" i18n-matTooltip>smart_toy</mat-icon>
                <div class="bg"></div>
            </div>
            <div *ngIf="item.value.updated_at === item.value.created_at" class="ai-wrapper">
                <mat-icon matTooltip="Pure response from AI" i18n-matTooltip>smart_toy</mat-icon>
            </div>
        </ng-container> -->

        <button
            [disabled]="disabled"
            class="circle-trigger doubled"
            (click)="$event.stopPropagation()"
            mat-button
            [matMenuTriggerFor]="menu"
            [matTooltip]="getToolTipValue(item.value.text_validation)"
        >
            <div class="circle-item {{ item.value.text_validation }}"></div>
        </button>
        <button
            mat-icon-button
            class="tools-btn-icon other-tools-btn"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="otherToolsMenu"
            #otherToolsMenuTrigger="matMenuTrigger"
            i18n-matTooltip="@@otherTools"
            matTooltip="Other tools"
        >
            <mat-icon class="kd-icon-24">spoke</mat-icon>
        </button>
        <mat-icon *ngIf="disabled" class="add-ai-btn on-loading">smart_toy</mat-icon>
    </ng-container>
    <button
        *ngIf="editMode.value"
        (click)="$event.stopPropagation(); editMode.next(false); onDisableSorting.emit(false)"
        class="tools-btn-icon"
        mat-icon-button
        matTooltip="Confirm"
        i18n-matTooltip="@@confirm"
    >
        <mat-icon>check</mat-icon>
    </button>
</div>
<app-kd-logo-loading *ngIf="loadingTitle.value" size="small"></app-kd-logo-loading>
<mat-menu #menu="matMenu">
    <a
        *ngFor="let validationBtn of validationColorBtns"
        class="indicator-btn {{ validationBtn.value }}"
        mat-menu-item
        (click)="changeColor(validationBtn.value)"
    >
        <div class="color-ball"></div>
        <span>{{ validationBtn.label }}</span>
    </a>
    <a class="indicator-btn revert" mat-menu-item (click)="changeColor('revert')">
        <div class="color-ball"></div>
        <span i18n>Revert</span>
    </a>
</mat-menu>
<mat-menu
    #otherToolsMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="other-tools-menu-backdrop"
>
    <!-- <a class="indicator-btn revert" mat-menu-item (click)="changeColor('revert')">
        <div class="color-ball"></div>
        <span i18n>Revert</span>
    </a> -->
    <button
        mat-icon-button
        class="tools-btn-icon other-tools-btn"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="addNewBlockMenu"
        #addNewBlockMenuTrigger="matMenuTrigger"
        i18n-matTooltip="@@otherTools"
        matTooltip="Other tools"
    >
        <mat-icon>add</mat-icon>
        <span i18n>Add new block</span>
        <mat-icon>expand_more</mat-icon>
    </button>

    <button
        [disabled]="!item.value.name"
        (click)="onCopy.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn copy"
        mat-button
    >
        <mat-icon class="material-icons-outlined">content_copy</mat-icon>
        <span i18n>Copy to clipboard</span>
    </button>
    <button
        *ngIf="item.value.id"
        [disabled]="!item.value.name"
        (click)="onCreateTestFromMaterial.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn copy"
        mat-button
    >
        <mat-icon fontSet="klickdata" fontIcon="kd-icon-test" class="create-quiz-tb"></mat-icon>
        <span i18n>Create a Quiz</span>
    </button>
    <button
        [disabled]="!item.value.name"
        (click)="onDuplicate.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn"
        mat-button
    >
        <mat-icon class="material-icons-outlined">file_copy</mat-icon>
        <span i18n>Duplicate</span>
    </button>
    <button [disabled]="disabled" (click)="sendEmail(); otherToolsMenuTrigger.closeMenu()" class="tools-btn" mat-button>
        <mat-icon class="material-icons-outlined">email</mat-icon>
        <span i18n>Mail text block</span>
    </button>
    <button
        *ngIf="item?.value?.id"
        [disabled]="disabled"
        (click)="viewItemLog(); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn log-file"
        mat-button
    >
        <mat-icon>touch_app</mat-icon>
        <span i18n>View log</span>
    </button>
    <button
        *ngIf="item?.value?.name"
        (click)="onDownload.emit(item); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn log-file"
        mat-button
    >
        <mat-icon>download</mat-icon>
        <span i18n>Download</span>
    </button>
    <button
        [disabled]="disabled"
        (click)="onDelete.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span i18n>Delete</span>
    </button>
</mat-menu>

<mat-menu
    #addNewBlockMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="add-new-block-menu-backdrop"
>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'text' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>post_add</mat-icon>
        <span i18n>Text block</span>
    </button>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'image' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_photo_alternate</mat-icon>
        <span i18n>Image block</span>
    </button>
    <!-- <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'file' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>cloud_upload</mat-icon>
        <span i18n>Upload file</span>
    </button> -->
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'link' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_link</mat-icon>
        <span i18n>Link block</span>
    </button>
</mat-menu>
